<div class="new-unit">
  <div class="content-head">
    <!-- 标题 -->
    <ng-container *ngIf="title; else titleSkeleton">
      <a
        class="title mutual-opacity onact96-not"
        [href]="domain + '/' + url"
        (click)="turn(); $event.preventDefault()"
        >{{ title }}</a
      >
    </ng-container>
    <ng-template #titleSkeleton>
      <div class="title skeleton-loading" style="width: 20%; height: 100%"></div>
    </ng-template>
    <ng-container *ngIf="hasData(); else arrowSkeleton">
      <a [href]="domain + '/' + url" *ngIf="showMore()" (click)="turn(); $event.preventDefault()">
        <div class="more-btn bg-btn onact96-not">
          {{ 'view_all' | translate }}
        </div>
      </a>
      <div class="arrow-group">
        <!-- 上一页 -->
        <div
          class="control-left bg-btn onact96"
          [class.disabled]="imgCarousel?.isBeginning"
          (click)="imgCarousel?.slidePrev()"
        >
          <i class="icon-left-arrow"></i>
        </div>
        <!-- 下一页 -->
        <div
          class="control-right bg-btn onact96"
          [class.disabled]="imgCarousel?.isEnd"
          (click)="imgCarousel?.slideNext()"
        >
          <i class="icon-right-arrow"></i>
        </div>
      </div>
    </ng-container>
    <ng-template #arrowSkeleton>
      <div class="arrow-group skeleton-loading" style="width: 10%; height: 100%"></div>
    </ng-template>
  </div>
  <ng-content select="[select='tabs']"></ng-content>
  <div class="content-body">
    <app-img-carousel #imgCarousel [config]="imgCarouselConfig" [itemsData]="renderData()">
      <ng-template #carouselItemTpl let-item let-index="index">
        <ng-container [ngSwitch]="for">
          <ng-container *ngSwitchCase="'game'">
            <app-game-unit
              [item]="item"
              [isProvider]="isProvider"
              (afterClickItem)="afterClickItem.emit($event)"
              (clickItem)="clickItem.emit($event)"
            ></app-game-unit>
          </ng-container>
          <ng-container *ngSwitchCase="'provider'">
            <app-provider-unit [item]="item"></app-provider-unit>
          </ng-container>
          <ng-container *ngSwitchCase="'label'">
            <app-label-unit [item]="item"></app-label-unit>
          </ng-container>
          <ng-container *ngSwitchCase="'sport'">
            <app-sport-unit [item]="item" [index]="index"></app-sport-unit>
          </ng-container>
        </ng-container>
      </ng-template>
    </app-img-carousel>
  </div>
</div>
